import React from 'react';
// Importar componentes de navegación e inicio de React Router
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Importar componente de toasts/notificaciones globales
import { Toaster } from 'react-hot-toast';
// Importar componente del Layout envolvente de la app
import Layout from './components/Layout';
// Importar páginas públicas de la aplicación
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login'; // <-- IMPORTANTE: Nueva página de Inicio de Sesión
// Importar páginas privadas (requieren sesión activa)
import Dashboard from './pages/Dashboard';
import Tests from './pages/Tests';
import Results from './pages/Results';
import Progress from './pages/Progress';
import Comparison from './pages/Comparison';
// Estilos globales de la aplicación
import './App.css';

// Componente Wrapper para proteger rutas privadas no autenticadas
function ProtectedRoute({ children }) {
  // La sesión válida depende del JWT, no de un objeto manipulable en localStorage.
  const authToken = localStorage.getItem('authToken');
  
  // activeParticipant es solo una caché de UI manipulable por el navegador; el JWT
  // y la autorización del backend son la fuente de verdad.
  if (!authToken) {
    return <Navigate to="/login" replace />;
  }
  
  // Si la sesión existe, renderizar de forma segura el componente hijo
  return children;
}

function App() {
  return (
    <Router>
      {/* El Layout envolvente con menú de navegación */}
      <Layout>
        <Routes>
          {/* Rutas Públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} /> {/* <-- Ruta de Inicio de Sesión */}

          {/* Rutas Privadas Resguardadas con el componente ProtectedRoute */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/tests" element={
            <ProtectedRoute>
              <Tests />
            </ProtectedRoute>
          } />
          <Route path="/results" element={
            <ProtectedRoute>
              <Results />
            </ProtectedRoute>
          } />
          <Route path="/progress" element={
            <ProtectedRoute>
              <Progress />
            </ProtectedRoute>
          } />
          <Route path="/comparison" element={
            <ProtectedRoute>
              <Comparison />
            </ProtectedRoute>
          } />
        </Routes>
      </Layout>
      {/* Componente para desplegar notificaciones emergentes Toast en toda la app */}
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;
